import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocialMediaStore } from '../../../stores/socialMediaStore';
import { Instagram, Youtube, Music } from 'lucide-react';
import type { Platform } from '../../../stores/socialMediaStore';

export default function ConnectedAccountsWidget() {
  const navigate = useNavigate();
  const accounts = useSocialMediaStore((state) => state.accounts);
  const connectedAccounts = accounts.filter(account => account.connected);

  const getPlatformIcon = (platform: Platform) => {
    switch (platform) {
      case 'instagram':
        return <Instagram className="h-5 w-5 text-pink-600" />;
      case 'youtube':
        return <Youtube className="h-5 w-5 text-red-600" />;
      case 'tiktok':
        return <Music className="h-5 w-5 text-black" />;
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Contas Conectadas
      </h3>
      
      {connectedAccounts.length === 0 ? (
        <div className="text-center py-6 bg-gray-50 rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-3"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          <p className="text-gray-600 mb-3">Nenhuma conta conectada</p>
          <button
            onClick={() => navigate('/dashboard/configuracoes?tab=redes-sociais')}
            className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
          >
            Conectar Agora
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {connectedAccounts.map(account => (
            <div key={account.platform} className="flex items-center p-3 bg-gray-50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-3">
                {getPlatformIcon(account.platform)}
              </div>
              <div>
                <p className="font-medium text-gray-900 capitalize">{account.platform}</p>
                <p className="text-sm text-gray-500">
                  Conectado como {account.username}
                </p>
              </div>
            </div>
          ))}
          
          <button
            onClick={() => navigate('/dashboard/configuracoes?tab=redes-sociais')}
            className="text-indigo-600 hover:text-indigo-700 text-sm font-medium"
          >
            Gerenciar Contas
          </button>
        </div>
      )}
    </div>
  );
}